// [VexFlow](https://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// MIT License
import { CommonMetrics } from '../src/fonts/common_metrics';
import { GonvilleSmuflFont } from '../src/fonts/gonville_glyphs';
export const Font = {
    data: GonvilleSmuflFont,
    metrics: CommonMetrics,
};
export default Font;
